import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Users from './components/Users';
import UsersEdit from './components/UsersEdit';
import Login from './components/Login';
import Profiles from './components/Profiles';
import AuthorizedRoute from './components/AuthorizedRoute';
import { useAuth } from './AuthContext';
import BenchmarkPerfisSAP from './components/benchmark_perfis_sap';
import ActionOrgLevel from './components/action_orglevel';
import ActionRisk from './components/action_risk';
import GeradorPerfis from './components/GeradorPerfis';
import GeradorPerfisWizard from './components/GeradorPerfisWizard';
import COwnerAdminClientes from './components/COwnerAdminClientes';
import COwnerCliente from './components/COwnerCliente';
import COwnerCockpit from './components/COwnerCockpit';
import Integrations from './components/Integrations';
import SapControlsRepository from './components/SapControlsRepository';
import GlobalClients from './components/GlobalClients';
import AnalisadorLogsSAP from './components/AnalisadorLogsSAP';
import JobMonitor from './components/JobMonitor';
import AppLayout from './components/AppLayout';
import AccessDesignSolution from './components/AccessDesignSolution';
import ADSCycle from './components/ADSCycle';
import ADSPortal from './components/ADSPortal';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* ADS Portal – public, outside AppLayout */}
        <Route caseSensitive path="/ADS/:slug" element={<ADSPortal />} />
        <Route element={isAuthenticated ? <AppLayout /> : <Navigate to="/login" />}> 
          <Route path="/home" element={<Home />} />
          <Route path="/users" element={<AuthorizedRoute element={<Users />} requiredLink="/users" />} />
        <Route
          path="/profiles"
          element={isAuthenticated ? <AuthorizedRoute element={<Profiles />} requiredLink="/profiles" /> : <Navigate to="/login" />}
        />
        <Route
          path="/integrations"
          element={isAuthenticated ? <AuthorizedRoute element={<Integrations />} requiredLink="/integrations" /> : <Navigate to="/login" />}
        />
        <Route
          path="/global-clients"
          element={isAuthenticated ? <AuthorizedRoute element={<GlobalClients />} requiredLink="/global-clients" /> : <Navigate to="/login" />}
        />
        <Route
          path="/job-monitor"
          element={isAuthenticated ? <AuthorizedRoute element={<JobMonitor />} requiredLink="/job-monitor" /> : <Navigate to="/login" />}
        />
        <Route
          path="/benchmark-perfis-sap"
          element={isAuthenticated ? <AuthorizedRoute element={<BenchmarkPerfisSAP />} requiredLink="/benchmark-perfis-sap" /> : <Navigate to="/login" />}
        />
        <Route
          path="/gerador-perfis"
          element={isAuthenticated ? <AuthorizedRoute element={<GeradorPerfis />} requiredLink="/gerador-perfis" /> : <Navigate to="/login" />}
        />
        <Route
          path="/analisador-logs-sap"
          element={isAuthenticated ? <AuthorizedRoute element={<AnalisadorLogsSAP />} requiredLink="/analisador-logs-sap" /> : <Navigate to="/login" />}
        />
        <Route
          path="/analisador-logs-sap/cliente/:analyzerClientId"
          element={isAuthenticated ? <AuthorizedRoute element={<AnalisadorLogsSAP />} requiredLink="/analisador-logs-sap" /> : <Navigate to="/login" />}
        />
        <Route
          path="/gerador-perfis/:clientId"
          element={isAuthenticated ? <AuthorizedRoute element={<GeradorPerfisWizard />} requiredLink="/gerador-perfis" /> : <Navigate to="/login" />}
        />
        <Route
          path="/action-orglevel"
          element={isAuthenticated ? <AuthorizedRoute element={<ActionOrgLevel />} requiredLink="/action-orglevel" /> : <Navigate to="/login" />}
        />
        <Route
          path="/action-risk"
          element={isAuthenticated ? <AuthorizedRoute element={<ActionRisk />} requiredLink="/action-risk" /> : <Navigate to="/login" />}
        />
        <Route
          path="/cowner-cockpit"
          element={isAuthenticated ? <AuthorizedRoute element={<COwnerCockpit />} requiredLink="/cowner-cockpit" /> : <Navigate to="/login" />}
        />
        <Route
          path="/cowner-admin-clientes"
          element={isAuthenticated ? <AuthorizedRoute element={<COwnerAdminClientes />} requiredLink="/cowner-admin-clientes" /> : <Navigate to="/login" />}
        />
        <Route
          path="/cowner-cliente/:clienteId"
          element={isAuthenticated ? <AuthorizedRoute element={<COwnerCliente />} requiredLink="/cowner-admin-clientes" /> : <Navigate to="/login" />}
        />
        <Route
          path="/sap-controls-repository"
          element={isAuthenticated ? <AuthorizedRoute element={<SapControlsRepository />} requiredLink="/sap-controls-repository" /> : <Navigate to="/login" />}
        />
        <Route
          path="/ads"
          element={isAuthenticated ? <AuthorizedRoute element={<AccessDesignSolution />} requiredLink="/ads" /> : <Navigate to="/login" />}
        />
        <Route
          path="/ads/:cycleId"
          element={isAuthenticated ? <AuthorizedRoute element={<ADSCycle />} requiredLink="/ads" /> : <Navigate to="/login" />}
        />
          <Route path="/users/edit/:id" element={<UsersEdit />} />
        </Route>
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
